module.exports = __webpack_public_path__ + "static/img/dingshuibao.e6cda9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/dingshuibao.png
// module id = pLGu
// module chunks = 0